import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'registration-entry-card',
  templateUrl: './registration-entry-card.component.html',
})
export class RegistrationEntryCardComponent {
  @Input()
  title = '';

  @Input()
  meta?: string;

  @Input()
  metaDir?: string;

  @Input()
  canDelete = true;

  @Input()
  showEdit = true;

  @Input()
  editTooltip = '';

  @Input()
  deleteTooltip = '';

  @Input()
  footerStartOnly = false;

  @Output()
  edit = new EventEmitter<void>();

  @Output()
  delete = new EventEmitter<void>();
}
